import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityIcon from "@mui/icons-material/Visibility";
// Removed material-ui-popup-state; using controlled MUI Menu
import SendIcon from "@mui/icons-material/Send";

import { toastMessage } from "utils/toastMessage";
import {
  approveProspect,
  rejectProspect,
  sendForApproval,
} from "_controllers/officer";
import { useSelector } from "react-redux";
import DealerProspectView from "./DealerProspectView";

import authAxios from "setups/axios";
import { BusinessCenter, DataObject } from "@mui/icons-material";
const CustomProgessBar = ({ size, value, color, type }) => {
  const circumference = 2 * 115 * 3.14 * (value <= 50 ? 50 : value) * 0.01;
  return (
    <>
      <div style={{ position: "relative", margin: "0 5px" }}>
        <svg width={size} height={size} viewBox="0 0 250 250">
          <circle
            className="bg"
            cx="125"
            cy="125"
            r="115"
            fill="none"
            stroke="#ddd"
            stroke-width="20"
          ></circle>
          <circle
            className="fg"
            cx="125"
            cy="125"
            r="115"
            fill="none"
            stroke={color}
            stroke-width="20"
            stroke-dasharray={circumference}
          ></circle>
        </svg>
        <div style={{ position: "absolute", top: 6, left: 7 }}>
          {Math.trunc(value)}
        </div>
        <div style={{ fontSize: "9px", textAlign: "center" }}>{type}</div>
      </div>
    </>
  );
};
const ProspectTable = ({
  data,
  header,
  setReload,
  remarkAction,
  openPreview,
  setOpenPreview,
  setProspectInfo,
  prospectInfo,
  openTimeline,
  setOpenTimeline,
  setProspectId1,
}) => {
  let user = useSelector((state) => state.user);

  const history = useHistory();

  const [userData, setUserData] = useState();
  const [open, setOpen] = useState(false);

  const sendToActyv = async (rowData) => {
    let data = await sendForApproval({ id: rowData._id, type: rowData.type });
    if (data?.status === "failure") {
      toastMessage(data?.message, data?.status);
    } else if (data?.status === "success") {
      setReload(rowData?._id);
      toastMessage("Prospect sent to Actyv", "success");
    }
  };

  console.log("prospect", data);
  const rejectAction = async (prospect) => {
    await rejectProspect(prospect.prospect_id, prospect.prospectType)
      .then((d) => {
        console.log("data", d);
        setReload(prospect.prospect_id);
        toastMessage(d?.data?.message, "success");
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
        toastMessage("error fetching data", "error");
      });
  };
  const approveAction = async (prospect) => {
    await approveProspect(prospect.prospect_id, prospect.prospectType)
      .then((d) => {
        console.log("data", d);
        setReload(prospect.prospect_id);
        toastMessage(d?.data?.message, "success");
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
        toastMessage("error fetching data", "error");
      });
  };
  const sendForE_Contract = async (rowData) => {
    // Perform the action for Button 2

    console.log("Button 2 clicked for row data:", rowData);
    const url = process.env.REACT_APP_REQUEST_ENDPOINT;

    const response = await authAxios()({
      url: `/api/v1/actyv/prospect/payment/${rowData?._id}?type=PROSPECT`,
      method: "POST",
    });
    console.log("res", response);
  };

  const reviewStatus = (rowData) => {
    // Perform the action for Button 3
    console.log("Button 3 clicked for row data:", rowData);
    toastMessage("Feature Under Development", "success");
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Menu state for actions per row
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuProspect, setMenuProspect] = useState(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const openMenu = (event, prospect) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuProspect(prospect);
  };
  const closeMenu = () => {
    setMenuAnchorEl(null);
    setMenuProspect(null);
  };

  console.log("data", data,"header", header);

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          minWidth: "60%",
          overflowX: "auto",
          height: "62vh",
        }}
      >
        <Table>
          {header && header.length > 0 ? (
            <TableHead>
              <TableRow>
                {header.map((item, idx) => (
                  <TableCell
                    align="left"
                    sx={{ fontWeight: "bolder" }}
                    key={idx}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          ) : null}

          <TableBody>
            {data && data?.length > 0 ? (
              data?.map((d) => (
                <TableRow key={d?._id}>
                  <TableCell align="left">
                    {d?.createdBy?.SAP_ID ?? "-"}
                  </TableCell>
                  <TableCell align="left">
                    {d?.businessInfo?.dealershipName ?? "-"}
                  </TableCell>
                  <TableCell align="left">
                    {d?.businessInfo?.email ?? "-"}
                  </TableCell>
                  <TableCell align="left">
                    {d?.businessInfo?.phoneNumber ?? "-"}
                  </TableCell>
                  {/* <TableCell align="left">
                    {d?.basicInfo?.firstPersonContact
                      ? d?.basicInfo?.firstPersonContact?.name
                      : "-"}
                  </TableCell> */}
                  {/* <TableCell align="left">
                    {d?.basicInfo?.firstPersonContact
                      ? moment
                        .utc(d?.basicInfo?.firstPersonContact?.dob)
                        .format("YYYY-MM-DD")
                      : "-"}
                  </TableCell> */}
                  <TableCell align="left">
                    {d?.basicInfo?.firstPersonContact
                      ? d?.basicInfo?.firstPersonContact?.phoneNumber
                      : "-"}
                  </TableCell>
                  <TableCell align="left">
                    <div style={{ display: "flex" }}>
                      <CustomProgessBar
                        size={30}
                        value={d?.actyvScore || 0}
                        color={"#ff8a80"}
                        type="ACTYV"
                      />
                      <CustomProgessBar
                        size={30}
                        value={d?.jkScore || 0}
                        color={"#fdbc00"}
                        type="JK"
                      />
                    </div>
                  </TableCell>
                  <TableCell align="left">
                    <VisibilityIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOpen(true);
                        setUserData(d);
                      }}
                    />
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      onClick={(e) => openMenu(e, d?.prosStatus)}
                      disabled={
                        !d?.prosStatus
                          ? true
                          : d?.prosStatus?.status?.includes("Pending")
                          ? false
                          : user?.user?.role == "ADMIN" &&
                            d?.prosStatus?.status == "Pending_HO"
                          ? false
                          : true
                      }
                    >
                      {d?.prosStatus ? d?.prosStatus?.status : "N/A"}
                    </Button>
                    <Menu anchorEl={menuAnchorEl} open={isMenuOpen} onClose={closeMenu}>
                      <MenuItem
                        onClick={() => {
                          if (menuProspect) approveAction(menuProspect);
                          closeMenu();
                        }}
                      >
                        Approve
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          if (menuProspect) rejectAction(menuProspect);
                          closeMenu();
                        }}
                      >
                        Reject
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          if (menuProspect) remarkAction({ close: closeMenu }, menuProspect);
                          closeMenu();
                        }}
                      >
                        Remark
                      </MenuItem>
                    </Menu>
                  </TableCell>
                  {/* {user.user.role == "ADMIN" ? */}
                  <TableCell align="left">
                    <Button
                      onClick={() => sendToActyv(d)}
                      variant="contained"
                      endIcon={<SendIcon />}
                      disabled={
                        d?.detailSendToActyv
                          ? true
                          : d?.prosStatus?.status === "Rejected"
                          ? true
                          : false
                      }
                      style={{ fontSize: "12px" }}
                    >
                      approval
                    </Button>
                  </TableCell>
                  {/* : ""
                  } */}
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      disabled={d?.documentLinks?.length > 0 ? false : true}
                      onClick={() => {
                        setOpenPreview(true);
                        setProspectInfo(d);
                      }}
                    >
                      Preview
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      onClick={() =>
                        history.push("/actyv-ai/dealer-form", {
                          from: "prospect_table",
                          prospectId: d?._id,
                          row: d, // pass full row for autofill on Dealer Onboard page
                        })
                      }
                    
                      variant="contained"
                      endIcon={<SendIcon />}
                      style={{ fontSize: "12px" }}
                    >
                      add
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      onClick={() => sendForE_Contract(d)}
                      variant="contained"
                      endIcon={<SendIcon />}
                      style={{ fontSize: "12px" }}
                    >
                      send
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    <IconButton
                      size="large"
                      color="primary"
                      onClick={() => {
                        setOpenTimeline(true);
                        setProspectId1(d?._id);
                      }}
                    >
                      <RemoveRedEyeIcon fontSize="inherit" />
                    </IconButton>
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      onClick={() => {
                        const dealerId = d?._id;
                        history.push(`/actyv-ai/dealer-form?dealerId=${dealerId}`, {
                          dealerId,
                        });
                      }}
                      style={{ fontSize: "12px" }}
                    >
                      View Onboard
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    {d?.userOnBoard?.sasApproval ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {d?.userOnBoard?.sasApproval === "accepted" ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✓</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.sasApproval}
                            </Typography>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.sasApproval}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                     
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                      <Typography variant="body2" >
                       
                        N/A
                      </Typography>

                       </Box>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {d?.userOnBoard?.soApproval ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {d?.userOnBoard?.soApproval === "accepted" ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✓</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.soApproval}
                            </Typography>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.soApproval}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                     
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                      <Typography variant="body2" >
                       
                        N/A
                      </Typography>

                       </Box>
                    )}
                  </TableCell>
                  {/* <TableCell align="left">
                    {d?.userOnBoard?.zoneApproval ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {d?.userOnBoard?.zoneApproval === "accepted" ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✓</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.zoneApproval}
                            </Typography>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.zoneApproval}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                     
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                      <Typography variant="body2" >
                       
                        N/A
                      </Typography>

                       </Box>
                    )}
                  </TableCell> */}
                  <TableCell align="left">
                    {d?.userOnBoard?.finalApproval ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {d?.userOnBoard?.finalApproval === "accepted" ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✓</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.finalApproval}
                            </Typography>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.finalApproval}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                     
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                      <Typography variant="body2" >
                       
                        N/A
                      </Typography>

                       </Box>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {console.log("Row data approvalStatus:", d?.approvalStatus, "Full row:", d)}
                    {d?.userOnBoard?.userOnBoard ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {d?.userOnBoard?.userOnBoard ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✓</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.userOnBoard?"True" : "False"}
                            </Typography>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                            <Typography variant="body2" >
                            {d?.userOnBoard?.userOnBoard?"True" : "False"}

                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                     
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                      <Typography variant="body2" >
                       
                        N/A
                      </Typography>

                       </Box>
                    )}
                  </TableCell>
                  <TableCell align="left">
                     {d?.userOnBoard?.paymentStatus ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                         
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✓</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.paymentStatus}
                            </Typography>
                          </Box>
                        
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                     
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                      <Typography variant="body2" >
                       
                        N/A
                      </Typography>

                       </Box>
                    )}
                  </TableCell>

                  <TableCell align="left">
                     {d?.userOnBoard?.kunnr ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✓</Typography>
                            <Typography variant="body2" >
                              {d?.userOnBoard?.kunnr}
                            </Typography>
                          </Box>
                        
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                     
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                      <Typography variant="body2" >
                       
                        N/A
                      </Typography>

                       </Box>
                    )}
                  </TableCell>
                  <TableCell align="left">
                     {d?.userOnBoard?.onboardingFailsReason ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                            <Typography variant="body2" >
                            {d?.userOnBoard?.onboardingFailsReason }

                            </Typography>
                          </Box>
                        
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                     
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>✗</Typography>
                      <Typography variant="body2" >
                       
                        N/A
                      </Typography>

                       </Box>
                    )}
                  </TableCell>
                  {/* <TableCell align="left">
                    <IconButton
                      size="large"
                      color="primary"
                      onClick={() => {
                        setOpenTimeline(true);
                        setProspectId1(d?._id);
                      }}
                    >
                      <BusinessCenter fontSize="inherit" />
                    </IconButton>
                  </TableCell> */}

                  {/* <TableCell align="left">
                    <Button onClick={() => reviewStatus(d)} variant="contained">
                      status
                    </Button>
                  </TableCell> */}
                </TableRow>
              ))
            ) : (
              <Box sx={{ textAlign: "left", pt: 1 }}>
                <Typography variant="h6" sx={{ p: 1 }}>
                  No Data.
                </Typography>
              </Box>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {open ? (
        <DealerProspectView
          handleClose={handleClose}
          data={userData}
          remarkAction={remarkAction}
          setReload={setReload}
        />
      ) : null}
    </>
  );
};

export default ProspectTable;
